<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content>
  <div class="form-container">
    <ng-template formHost></ng-template>
  </div>

  <button (click)="onSave()" mat-button>Save</button>
</page-content>

